import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, TemplateRef } from '@angular/core';
import { GridColumn, GridConfiguration, GridSorting } from '../teiasoft-grid-odata.component';
import { Globals } from 'src/app/shared/globals/globals';
import { SelectOption } from '../../teiasoft-select/teiasoft-select.component';
import { TranslateService } from '@ngx-translate/core';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { moveItemInArray } from '@angular/cdk/drag-drop';

declare var $: any;

export class GridSortCriteria {
  column?: string;
  direction?: string;
  availColumns?: SelectOption[];
}

@Component({
  selector: 'teiasoft-grid-settings',
  templateUrl: './teiasoft-grid-settings.component.html',
  styleUrls: ['./teiasoft-grid-settings.component.scss']
})

export class TeiasoftGridSettingsComponent implements OnInit, OnDestroy {
  @Input() isMobile: boolean = false;
  @Input() theme: string = "";
  @Input() gridConfiguration: GridConfiguration = new GridConfiguration();
  @Input() labelText: string = "";
  @Input() columnDisabled: string[] = [];
  @Input() hiddenColumns: string[] = [];
  @Input() disableSortingCriteria = false;
  @Input() disableHideFeature = false;
  @Input() disableFreezeFeature = true;
  @Input() frozenColumns: number = 0;  // Default: No frozen columns
  @Input() customHeaderRenderers: { [key: string]: () => { template: TemplateRef<any>, context: any } } = {};

  @Output() onClose: EventEmitter<any> = new EventEmitter();
  @Output() onApply: EventEmitter<GridConfiguration> = new EventEmitter();

  directionOptions: SelectOption[] = [
    { value: 'asc', text: this.translateService.instant("grid.asc") },
    { value: 'desc', text: this.translateService.instant("grid.desc") }
  ];

  gridSortCriteria: GridSortCriteria[] = new Array();
  columns: GridColumn[] = new Array();
  oldGridConfiguration: string = "";
  private readonly columnGroupingOptionsKey = 'columnGrouping';
  private groupedColumnsLookup: Set<string> = new Set<string>();
  private groupedColumnRanges: string[][] = [];
  private customHeaderLabelsCache: { [key: string]: string } = {};

  // DRAG
  dragColFrom?: any;
  dragColTo?: any;
  dragColFromE?: any;
  dragColToE?: any;

  constructor(public globals: Globals, private translateService: TranslateService) {
    $('body').addClass('no-scroll');
  }


  ngOnInit(): void {
    this.oldGridConfiguration = JSON.stringify(this.gridConfiguration);
    this.fillColumns();
    if (!this.gridConfiguration.gridSortings || this.gridConfiguration.gridSortings!.length == 0) {
      // Empty first criteria row
      //this.addCriteriaRow();
    } else {
      this.fillGridSorting();
    }
    this.initGridConfiguration();
  }

  private initGridConfiguration() {
    this.gridConfiguration.frozenColumns = this.gridConfiguration.frozenColumns ?? 0;
    this.frozenColumns = this.gridConfiguration.frozenColumns;
  }

  ngOnDestroy(): void {
    $('body').removeClass('no-scroll');
  }

  /* METHODS */
  fillColumns() {
    this.columns = new Array();
    for (var x = 0; x < this.gridConfiguration.gridColumns!.length; x++) {
      if (!this.columnDisabled.includes(this.gridConfiguration.gridColumns![x].name!))
        this.columns.push(this.gridConfiguration.gridColumns![x]);
    }

    // Rebuild index
    for (var x = 0; x < this.columns.length; x++) {
      this.columns[x].position = (x + 1);
    }

    this.rebuildGroupedColumnsState();
  }

  fillGridSorting() {
    if (!this.gridSortCriteria) this.gridSortCriteria = new Array();
    let _temp: string[] = new Array();
    for (var x = 0; x < this.gridConfiguration.gridSortings!.length; x++) {
      let _item: GridSortCriteria = new GridSortCriteria();
      _item.column = this.gridConfiguration.gridSortings![x].column;
      _item.direction = this.gridConfiguration.gridSortings![x].direction;
      _temp.push(_item.column!);
      _item.availColumns = new Array();
      for (var c = 0; c < this.columns.length; c++) {
        let _item2: SelectOption = new SelectOption();
        _item2.text = this.getColumnDisplayLabel(this.columns[c].name!);
        _item2.value = this.columns[c].name!;
        _item.availColumns.push(_item2);
      }
      this.gridSortCriteria.push(_item);
    }

    for (var x = 0; x < this.gridSortCriteria.length; x++) {
      for (var c = 0; c < _temp.length; c++) {
        let _i: number = this.gridSortCriteria[x].availColumns!.findIndex(x => x.value == _temp[c]);
        this.gridSortCriteria[x].availColumns!.splice(_i, 1);
      }
    }
  }

  addCriteriaRow() {
    if (!this.gridSortCriteria) this.gridSortCriteria = new Array();
    let _item: GridSortCriteria = new GridSortCriteria();
    _item.availColumns = new Array();
    for (var x = 0; x < this.columns.length; x++) {
      let _i: number = this.gridSortCriteria.findIndex(c => c.column == this.columns[x].name!)
      if (_i == -1) {
        let _option: SelectOption = new SelectOption();
        _option.text = this.getColumnDisplayLabel(this.columns[x].name!);
        _option.value = this.columns[x].name!;
        _item.availColumns.push(_option);
      }
    }
    this.gridSortCriteria.push(_item);
  }

  /* CRITERIA METHODS FOR DISPLAY */
  getCriteriaTitle(index: number): string {
    if (index == 0)
      return this.translateService.instant("grid.sortby");
    else
      return this.translateService.instant("grid.thenby");
  }

  showAddCriteriaIcon(index: number): boolean {
    if (index < (this.gridSortCriteria.length - 1))
      return false;
    else
      return true;
  }

  showRemoveCriteriaIcon(index: number): boolean {
    return true;

    if (this.gridSortCriteria.length == 1)
      return false;
    else
      return true;
  }

  buildGridSorting() {
    this.gridConfiguration.gridSortings = new Array();
    for (var x = 0; x < this.gridSortCriteria.length; x++) {
      if (this.gridSortCriteria[x].column && this.gridSortCriteria[x].column != '' && this.gridSortCriteria[x].direction && this.gridSortCriteria[x].direction != '') {
        let _item: GridSorting = new GridSorting();
        _item.column = this.gridSortCriteria[x].column;
        _item.direction = this.gridSortCriteria[x].direction;
        this.gridConfiguration.gridSortings.push(_item);
      }
    }
  }

  buildGridColumns() {
    // ADD THE COLUMN HIDED

    this.gridConfiguration.gridColumns = new Array();
    let _columns: string = JSON.stringify(this.columns);
    this.gridConfiguration.gridColumns = JSON.parse(_columns);

    if (this.columnDisabled.length > 0) {
      // _temp.position = 0;
      // this.gridConfiguration.gridColumns?.unshift(_temp);
    }

    _columns = "";
  }

  getDirectionName(direction: string): string {
    if (direction == undefined) return "";
    let _i: number = this.directionOptions!.findIndex(x => x.value == direction);
    return this.directionOptions[_i].text;
  }

  /* EVENTS */
  onApplyModalClick() {
    this.buildGridSorting();
    this.buildGridColumns();
    this.calculateActiveFrozenColumns();
    this.onApply.emit(this.gridConfiguration);
  }

  onCloseModalClick() {
    this.gridConfiguration = new GridConfiguration();
    this.gridConfiguration = JSON.parse(this.oldGridConfiguration);
    this.onClose.emit(this.oldGridConfiguration);
  }

  onSetVisibileClick(col: GridColumn) {
    if (!this.canToggleColumnVisibility(col)) return;
    let _i: number = this.columns.findIndex(x => x.name == col.name!);
    this.columns[_i].visible = !this.columns[_i].visible;

    this.calculateActiveFrozenColumns();
  }

  onPositionChange(col: GridColumn, dir: string) {
    const fromIndex = this.findColumnIndexByName(col.name);
    if (fromIndex === -1) return;

    const toIndex = dir == 'up' ? fromIndex - 1 : fromIndex + 1;
    this.tryReorderColumns(fromIndex, toIndex);
  }

  onSetAllVisInvisClick(visible: boolean) {
    this.columns.filter(column => !this.isColumnLockedInSettings(column)).forEach(column => {
      column.visible = visible;
    });
  }

  colsCheck(): string {
    const mutableColumns = this.columns.filter(col => !this.isColumnLockedInSettings(col));
    if (mutableColumns.length === 0) return 'none';

    if (mutableColumns.findIndex(x => x.visible == true) == -1)
      return 'none';

    if (mutableColumns.findIndex(x => x.visible == false) == -1)
      return 'all';

    return 'some';
  }

  onAddCriteriaClick(item: GridSortCriteria) {
    if (item.column == undefined || item.direction == undefined) return;
    this.addCriteriaRow();
  }

  onRemoveCriteriaClick(index: number) {
    this.gridSortCriteria.splice(index, 1);
  }

  onSelectCriteriaColumn(evt: SelectOption, index: number) {
    this.gridSortCriteria[index].column = evt.value;
  }

  onSelectCriteriaDirection(evt: SelectOption, index: number) {
    this.gridSortCriteria[index].direction = evt.value;
  }

  getColumnDisplayLabel(columnName: string): string {
    if (this.customHeaderLabelsCache[columnName]) {
      return this.customHeaderLabelsCache[columnName];
    }

    const customHeaderLabel = this.getCustomHeaderLabel(columnName);
    const label = customHeaderLabel || this.translateColumnName(columnName);
    this.customHeaderLabelsCache[columnName] = label;
    return label;
  }

  private translateColumnName(columnName: string): string {
    return this.translateService.instant('grid.' + this.capitalizeFirstLetter(columnName));
  }

  private getCustomHeaderLabel(columnName: string): string {
    const rendererFactory = this.customHeaderRenderers[columnName];
    if (!rendererFactory) return "";

    const renderer = rendererFactory();
    if (!renderer?.template) return "";

    const view = renderer.template.createEmbeddedView(renderer.context ?? {});
    view.detectChanges();
    const text = view.rootNodes
      .map(node => this.extractNodeText(node))
      .join(' ')
      .replace(/\s+/g, ' ')
      .trim();
    view.destroy();

    return text;
  }

  private extractNodeText(node: any): string {
    if (!node) return "";

    if (typeof node.textContent === 'string') {
      return node.textContent;
    }

    if (!node.childNodes || node.childNodes.length === 0) {
      return "";
    }

    return Array.from(node.childNodes)
      .map((child: any) => this.extractNodeText(child))
      .join(' ');
  }

  reorderColumns() {
    // Clear the list from the element to move
    let _posFrom: number = parseInt(this.dragColFrom.srcElement.id.replace('div_', '').replace('iconame_', '').replace('icochk_', '').replace('icoarrows_', '').replace('spanname_', ''));
    let _temp: GridColumn[] = new Array();
    _temp = this.columns.filter(x => x.position != _posFrom);

    if (Number.isNaN(_posFrom)) return;

    // take the element to move
    let _itemToAdd: GridColumn = new GridColumn();
    _itemToAdd = this.columns.filter(x => x.position == _posFrom)[0];

    // Take the position of the element to replace
    let _posTo: number = parseInt(this.dragColTo.srcElement.id.replace('div_', '').replace('iconame_', '').replace('icochk_', '').replace('icoarrows_', '').replace('spanname_', ''));

    if (Number.isNaN(_posTo)) return;

    // Insert the element
    _temp.splice((_posTo - 1), 0, _itemToAdd);

    // Rebuild positions
    for (var x = 0; x < _temp.length; x++) {
      _temp[x].position = (x + 1);
    }

    this.columns = JSON.parse(JSON.stringify(_temp));

    console.log("Moved from " + _posFrom + "(" + this.dragColFrom.srcElement.id + ") to " + _posTo + " (" + this.dragColTo.srcElement.id + ")");
  }

  capitalizeFirstLetter(str: string) {
    return str.charAt(0).toUpperCase() + str.slice(1)
  }

  drop(event: CdkDragDrop<any[]>) {
    if (event.previousIndex !== event.currentIndex) {
      const visible = this.visibleColumns;
      const fromCol = visible[event.previousIndex];
      const toCol = visible[event.currentIndex];
      if (!fromCol || !toCol) return;

      const fromIndex = this.findColumnIndexByName(fromCol.name);
      const toIndex = this.findColumnIndexByName(toCol.name);
      this.tryReorderColumns(fromIndex, toIndex);
    }
  }

  onSetFrozenColumns(position: number) {
    if (this.frozenColumns === position) {
      // Clicking the same lock should reset (freeze 0 columns)
      this.frozenColumns = 0;
    } else {
      this.frozenColumns = position;
    }

    this.gridConfiguration.frozenColumns = this.frozenColumns;

    this.calculateActiveFrozenColumns();

  }


  calculateActiveFrozenColumns() {
    const hiddenFrozenColumnCount = this.gridConfiguration.gridColumns?.filter(gc => !gc.visible && gc.position! <= this.frozenColumns).length || 0;

    this.gridConfiguration.activeFrozenColumns = this.frozenColumns - hiddenFrozenColumnCount;
  }

  get visibleColumns() {
    const hidden = this.hiddenColumns ?? [];
    return this.columns.filter(c => !hidden.includes(c.name!));
  }

  isColumnLockedInSettings(col: GridColumn): boolean {
    return this.groupedColumnsLookup.has(this.normalizeColumnName(col.name));
  }

  canToggleColumnVisibility(col: GridColumn): boolean {
    return !this.isColumnLockedInSettings(col);
  }

  canSetColumnFreeze(col: GridColumn): boolean {
    return !this.isColumnLockedInSettings(col);
  }

  canMoveColumn(col: GridColumn, dir: 'up' | 'dw'): boolean {
    const fromIndex = this.findColumnIndexByName(col.name);
    if (fromIndex === -1) return false;

    const toIndex = dir == 'up' ? fromIndex - 1 : fromIndex + 1;
    return this.canReorderColumns(fromIndex, toIndex);
  }

  private tryReorderColumns(fromIndex: number, toIndex: number): void {
    if (!this.canReorderColumns(fromIndex, toIndex)) return;

    const nextColumns = [...this.columns];
    moveItemInArray(nextColumns, fromIndex, toIndex);
    this.columns = nextColumns;
    this.rebuildColumnsPosition();
  }

  private canReorderColumns(fromIndex: number, toIndex: number): boolean {
    if (fromIndex < 0 || toIndex < 0 || fromIndex >= this.columns.length || toIndex >= this.columns.length) {
      return false;
    }
    if (fromIndex === toIndex) return false;

    const fromColumn = this.columns[fromIndex];
    const toColumn = this.columns[toIndex];
    if (!fromColumn || !toColumn) return false;
    if (this.isColumnLockedInSettings(fromColumn) || this.isColumnLockedInSettings(toColumn)) {
      return false;
    }

    const nextColumns = [...this.columns];
    moveItemInArray(nextColumns, fromIndex, toIndex);
    return this.isGroupingLayoutValid(nextColumns);
  }

  private isGroupingLayoutValid(columns: GridColumn[]): boolean {
    if (this.groupedColumnRanges.length === 0) return true;

    const orderedNames = columns.map(col => this.normalizeColumnName(col.name));
    for (const groupRange of this.groupedColumnRanges) {
      if (groupRange.length <= 1) continue;

      const positions = groupRange
        .map(colName => orderedNames.findIndex(name => name === colName))
        .filter(idx => idx !== -1)
        .sort((a, b) => a - b);

      if (positions.length <= 1) continue;

      const span = positions[positions.length - 1] - positions[0] + 1;
      if (span !== positions.length) {
        return false;
      }
    }

    return true;
  }

  private rebuildGroupedColumnsState(): void {
    this.groupedColumnsLookup = new Set<string>();
    this.groupedColumnRanges = [];

    const rawGroups = this.gridConfiguration.options?.[this.columnGroupingOptionsKey]?.groups;
    if (!Array.isArray(rawGroups) || rawGroups.length === 0) return;

    const orderedNames = this.columns.map(col => this.normalizeColumnName(col.name));
    rawGroups.forEach((group: any) => {
      const startColumn = this.normalizeColumnName(group?.startColumn);
      const endColumn = this.normalizeColumnName(group?.endColumn);
      if (!startColumn || !endColumn) return;

      const startIndex = orderedNames.findIndex(name => name === startColumn);
      const endIndex = orderedNames.findIndex(name => name === endColumn);
      if (startIndex === -1 || endIndex === -1) return;

      const from = Math.min(startIndex, endIndex);
      const to = Math.max(startIndex, endIndex);
      const groupRange = orderedNames.slice(from, to + 1);
      if (groupRange.length === 0) return;

      this.groupedColumnRanges.push(groupRange);
      groupRange.forEach(colName => this.groupedColumnsLookup.add(colName));
    });
  }

  private rebuildColumnsPosition(): void {
    this.columns.forEach((col, index) => {
      col.position = index + 1;
    });
  }

  private findColumnIndexByName(colName?: string): number {
    const normalized = this.normalizeColumnName(colName);
    return this.columns.findIndex(col => this.normalizeColumnName(col.name) === normalized);
  }

  private normalizeColumnName(colName?: string): string {
    return (colName ?? '').toLowerCase();
  }
}
